import React from 'react';
import PropTypes from 'prop-types';

const NotificationsPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M12.033 4.954C8.112 6.557 5.5 10.418 5.5 14.667v5.25a2.92 2.92 0 0 1-2.917 2.916.583.583 0 0 0 0 1.167h26.834a.582.582 0 1 0 0-1.167 2.92 2.92 0 0 1-2.917-2.916v-5.25c0-4.248-2.614-8.11-6.537-9.713A4.054 4.054 0 0 0 16 1.834c-1.88 0-3.528 1.319-3.967 3.12zM12.5 26a.585.585 0 0 0-.584.584A4.088 4.088 0 0 0 16 30.667a4.088 4.088 0 0 0 4.083-4.083A.584.584 0 0 0 19.5 26h-7z"
    />
  );
};

NotificationsPath.propTypes = {
  fill: PropTypes.string,
};

export default NotificationsPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/features-navigation/notifications.jsx